/** @format */

import {useState, useRef, useEffect} from 'react';
import SuperAgent from 'superagent';

export const useSave = (endpoint, debounceDelay = 500) => {
    const [isSaving, setIsSaving] = useState(false);
    const [success, setSuccess] = useState(false);
    const requestRef = useRef(null);
    const timerRef = useRef(null);
    const [error, setError] = useState(null);

    useEffect(() => {
        return () => {
            // Clear any pending timeout when the component unmounts
            if (timerRef.current) {
                clearTimeout(timerRef.current);
            }

            // Abort any ongoing request when the component unmounts
            if (requestRef.current) {
                requestRef.current.abort();
            }
        };
    }, []);

    const save = data => {
        if (timerRef.current) {
            clearTimeout(timerRef.current);
        }

        return new Promise((resolve, reject) => {
            timerRef.current = setTimeout(async () => {
                if (requestRef.current) {
                    requestRef.current.abort();
                }
                setIsSaving(true);
                setError(null);

                try {
                    requestRef.current = SuperAgent.post(endpoint)
                        .set('accept', 'application/json')
                        .send(data);
                    const response = await requestRef.current;
                    setIsSaving(false);
                    setSuccess(true);
                    resolve(response);
                } catch (err) {
                    setIsSaving(false);
                    if (err?.response?.body?.message) {
                        setError(err.response.body.message);
                    } else {
                        setError(err.message || 'Something went wrong.');
                    }
                    setSuccess(false);
                    resolve(false);
                } finally {
                    requestRef.current = null;
                    resolve(false);
                }
            }, debounceDelay);
        });
    };

    return {save, isSaving, error, success};
};
